import styles from '../product-timeline.module.scss';
import React from 'react';

const IconDownloadView: React.FC = () => {
  return (
    <span className={styles.ordersSales__mainRight__steps__step__btn__iconDownload}>
      <svg viewBox="0 0 24 24">
        <path
          d="M10.5 2.5V14.375M10.5 14.375L4.5625 8.4375M10.5 14.375L16.4375 8.4375"
          stroke="black"
        />
        <path
          d="M3.00002 17.1875L18 17.1875"
          stroke="black"
        />
      </svg>
    </span>
  );
};

export default IconDownloadView;
